/** font_0   Site Title  Title
    font_2  Page Title  Page-title
    font_3  Huge Heading    Heading-XL
    font_4  Large Heading   Heading-L
    font_5  Basic Heading   Heading-M
    font_6  Small Heading   Heading-S
    font_7  Paragraph 1 Body-L
    font_8  Paragraph 2 Body-M
    font_9  Paragraph 3 Body-S
**/
import { CssColor, CssFont } from '@wix/editor-platform-ooi-metadata-resolver';
import { ISiteTextPreset } from '@wix/native-components-infra/dist/src/types/wix-sdk';

const DefaultDesign = {
  questionText: {
    color: {
      name: 'questionTextColor',
      dataHook: 'questionTextColorPicker',
      type: 'ColorPickerInput',
      value: 'color-text-primary',
      editor3Value: CssColor.WstParagraph2Color, //  'wst-paragraph-2-color'
    },
    font: {
      name: 'questionTextFont',
      type: 'FontPicker',
      value: 'Body-M' as keyof ISiteTextPreset,
      editor3Value: CssFont.WstParagraph2Font, //  'wst-paragraph-2-font'
      theme: 'font_7',
      hideTheme: false,
      showHTMLTag: true,
      htmlTag: 'h3',
      startWithSize: 20,
      lineHeight: 24,
      startWithMobileSize: 20,
      fontMaxSize: 40,
      hideStyle: false,
    },
  },
  questionStripesText: {
    color: {
      name: 'questionStripesTextColor',
      dataHook: 'questionStripesTextColorPicker',
      type: 'ColorPickerInput',
      value: 'color-5',
      editor3Value: CssColor.WstParagraph2Color, //  'wst-paragraph-2-color'
    },
    font: {
      name: 'questionStripesTextFont',
      type: 'FontPicker',
      value: 'Heading-S' as keyof ISiteTextPreset,
      editor3Value: CssFont.WstHeading6Font, //  'wst-heading-6-font'
      theme: 'font_6',
      hideTheme: false,
      showHTMLTag: true,
      htmlTag: 'h3',
      startWithSize: 25,
      fontMaxSize: 40,
      hideStyle: false,
    },
  },
  answerText: {
    color: {
      name: 'answerTextColor',
      dataHook: 'answerTextColorPicker',
      type: 'ColorPickerInput',
      value: 'color-text-primary',
      editor3Value: CssColor.WstParagraph2Color, //  'wst-paragraph-2-color'
    },
    font: {
      name: 'answerTextFont',
      type: 'FontPicker',
      value: 'Body-M' as keyof ISiteTextPreset,
      editor3Value: CssFont.WstParagraph2Font, //  'wst-paragraph-2-font'
      theme: 'font_8',
      hideTheme: false,
      showHTMLTag: false,
      startWithSize: 16,
      lineHeight: 24,
      fontMaxSize: 40,
      hideStyle: true,
    },
  },

  answersLinks: {
    color: {
      name: 'answersLinksColor',
      dataHook: 'answersLinksColorPicker',
      type: 'ColorPickerInput',
      value: 'color-action',
      editor3Value: CssColor.WstLinksAndActionsColor, //  'wst-links-and-actions-color'
    },
  },
  questionNumberText: {
    color: {
      name: 'questionNumberTextColor',
      dataHook: 'questionNumberTextColorPicker',
      type: 'ColorPickerInput',
      value: 'color-fill-background-primary',
      editor3Value: CssColor.WstPrimaryBackgroundColor, //  'wst-primary-background-color'
    },
    font: {
      name: 'questionNumberTextFont',
      type: 'FontPicker',
      value: 'Body-M' as keyof ISiteTextPreset,
      editor3Value: CssFont.WstParagraph2Font, //  'wst-paragraph-2-font'
      theme: 'font_2',
      hideTheme: false,
      showHTMLTag: false,
      startWithSize: 20,
      startWithMobileSize: 60,
      fontMaxSize: 60,
    },
  },
  questionNumberHover: {
    color: {
      name: 'questionNumberHover',
      dataHook: 'questionNumberHoverPicker',
      type: 'ColorPickerInput',
      value: 'color-8',
      editor3Value: CssColor.WstLinksAndActionsColor, // 'wst-links-and-actions-color',
      opacity: 1,
    },
  },
  questionNumberBgColor: {
    color: {
      name: 'questionNumberBgColor',
      dataHook: 'questionNumberBgColorPicker',
      type: 'ColorPickerInput',
      value: 'color-action',
      editor3Value: CssColor.WstLinksAndActionsColor, //  'wst-links-and-actions-color'
      opacity: 1,
    },
    border: {
      name: 'numberQuestionsLayoutBorderWidth',
      type: 'slider',
      min: 0,
      max: 6,
      unit: 'px',
      value: 0,
    },
  },
  numberQuestionsLayoutBorder: {
    color: {
      name: 'numberQuestionsLayoutBorderColor',
      dataHook: 'numberQuestionsLayoutBorderColorPicker',
      type: 'ColorPickerInput',
      value: 'color-action',
      editor3Value: CssColor.WstLinksAndActionsColor, // 'wst-links-and-actions-color',
      opacity: 1,
    },
    border: {
      name: 'numberQuestionsLayoutBorderWidth',
      type: 'slider',
      min: 0,
      max: 6,
      unit: 'px',
      value: 0,
    },
  },
  numberAnswersLayoutBorder: {
    color: {
      name: 'numberAnswersLayoutBorderColor',
      dataHook: 'numberAnswersLayoutBorderColorPicker',
      type: 'ColorPickerInput',
      value: 'color-line',
      editor3Value: CssColor.WstSystemLine1Color, //  'wst-system-line-1-color'
      opacity: 1,
    },
    border: {
      name: 'numberAnswersLayoutBorderWidth',
      type: 'slider',
      min: 0,
      max: 6,
      unit: 'px',
      value: 1,
    },
  },
  numberAnswersLayoutBgColor: {
    name: 'numberAnswersLayoutBgColor',
    dataHook: 'numberAnswersLayoutBgColorPicker',
    type: 'ColorPickerInput',
    value: 'color-fill-background-primary',
    editor3Value: CssColor.WstPrimaryBackgroundColor, //  'wst-primary-background-color'
    opacity: 0,
  },
  headerText: {
    color: {
      name: 'headerTextColor',
      dataHook: 'headerTextColorPicker',
      type: 'ColorPickerInput',
      value: 'color-title',
      editor3Value: CssColor.WstHeading2Color, //  'wst-heading-2-color'
    },
    font: {
      name: 'headerTextFont',
      type: 'FontPicker',
      value: 'Heading-M' as keyof ISiteTextPreset,
      editor3Value: CssFont.WstHeading5Font, //  'wst-heading-5-font'
      theme: 'font_5',
      hideTheme: false,
      showHTMLTag: true,
      htmlTag: 'h2',
      fontMaxSize: 100,
      startWithSize: 32,
      startWithMobileSize: 24,
    },
  },

  categoryOtherText: {
    color: {
      name: 'categoryOtherTextColor',
      dataHook: 'categoryOtherTextColorPicker',
      type: 'ColorPickerInput',
      value: 'color-text-primary',
      editor3Value: CssColor.WstParagraph2Color, //  'wst-paragraph-2-color'
    },
    font: {
      name: 'categoryOtherTextFont',
      type: 'FontPicker',
      value: 'Body-M' as keyof ISiteTextPreset,
      editor3Value: CssFont.WstParagraph2Font, //  'wst-paragraph-2-font'
      theme: 'font_9',
      hideTheme: false,
      showHTMLTag: false,
      fontMaxSize: 40,
      startWithSize: 16,
    },
  },
  selectedCategory: {
    color: {
      name: 'selectedCategoryTextColor',
      dataHook: 'selectedCategoryTextColorPicker',
      type: 'ColorPickerInput',
      value: 'color-action',
      editor3Value: CssColor.WstLinksAndActionsColor, //  'wst-links-and-actions-color'
      opacity: 1,
    },
  },
  widget: {
    color: {
      name: 'widgetBgColor',
      dataHook: 'widgetBgColorPicker',
      type: 'ColorPickerSlider',
      value: 'color-fill-background-primary',
      editor3Value: CssColor.WstPrimaryBackgroundColor, //  'wst-primary-background-color'
      opacity: 1,
    },
  },
  dividerCollapse: {
    color: {
      name: 'stripColor',
      dataHook: 'ColorPickerSliderPicker',
      type: 'ColorPickerSlider',
      value: 'color-line',
      editor3Value: CssColor.WstSystemLine1Color, //  'wst-system-line-1-color'
      opacity: 1,
    },
    border: {
      name: 'dividerWidth',
      type: 'slider',
      min: 1,
      max: 6,
      unit: 'px',
    },
  },
  mobile: {
    title: {
      font: {
        name: 'mobileTitleFontSize',
        startWithSize: 20,
        fontMinSize: 12,
        fontMaxSize: 40,
      },
    },
    category: {
      font: {
        name: 'mobileCategoryFontSize',
        startWithSize: 16,
        fontMinSize: 12,
        fontMaxSize: 24,
      },
    },
    questionsNumber: {
      font: {
        name: 'mobileQuestionsNumberFontSize',
        startWithSize: 50,
        fontMinSize: 12,
        fontMaxSize: 60,
      },
    },
    questions: {
      font: {
        name: 'mobileQuestionsFontSize',
        startWithSize: 16,
        fontMinSize: 12,
        fontMaxSize: 24,
      },
    },
    answers: {
      font: {
        name: 'mobileAnswersFontSize',
        startWithSize: 14,
        fontMinSize: 12,
        fontMaxSize: 24,
      },
    },
  },
};

export default DefaultDesign;
